import React, { useRef } from 'react';

import emailjs from "@emailjs/browser";
import toast from "react-hot-toast";

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
      e.target.reset();
      toast.success('Thanks for your contact');
      emailjs
        .sendForm(
          "service_ty3tvuo",
          "template_vv3i2oc",
          form.current,
          "S3hmVPmmy-Nd0nFCQ"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
    };
    return (
        <section>
          <div className="w-1/2 mx-auto py-6">
            <h2 className="text-red-500 text-center text-4xl font-semibold my-6">Connect with Me</h2>
            <form ref={form} onSubmit={sendEmail}>
              <div>
              <label className="text-white">Name</label> <br />
              <input type="text" name="user_name" className="border-0 bg-transparent border-b-2 border-b-red-500 w-full text-white focus:outline-none"/>
              </div>
              <div>
              <label className="text-white">Email</label> <br />
              <input type="email" name="user_email" className="border-0 bg-transparent border-b-2 border-b-red-500 w-full text-white focus:outline-none"/>
              </div>
              <div>
              <label className="text-white">Message</label> <br />
              <textarea name="message" className="border-0 bg-transparent border-b-2 border-b-red-500 w-full text-white focus:outline-none"/> <br />
              <input className="text-white px-5 py-2 bg-red-500 rounded-sm w-full" type="submit" value="Send" />
              </div>
            </form>
          </div>
        </section>
    );
};

export default Contact;